import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/Index'
import Fashion from '../views/Fashion'
import ServiceAndSupport from '../views/ServiceAndSupport.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/productDetail',
            name: 'productDetail',
            component: () => import('@/views/productDetail'),
        },
        {
            path: '/caseUser',
            name: 'caseUser',
            component: () => import('@/views/caseUser'),
            children: [
                {
                    path: '/caseEducation',
                    name: 'caseEducation',
                    component: () => import('@/views/caseEducation'),
                },
                {
                    path: '/caseEducationFrim',
                    name: 'caseEducationFrim',
                    component: () => import('@/views/caseEducationFrim'),
                }
            ]
        },
        {
            path: '/aboutUs',
            name: 'aboutUs',
            component: () => import('@/views/aboutUs'),
        },
        {
            path: '/fashion',
            name: 'Fashion',
            component: Fashion
        },
        {
            path: '/serviceAndSupport',
            name: 'ServiceAndSupport',
            component: () => import('@/views/ServiceAndSupport.vue'),
        }
    ]
})
